import { useEffect, type ReactNode } from "react";
import { Link, useLocation } from "react-router-dom";
import { META } from "./metadata";
import "./public.css";

export function PublicLayout({ children }: { children: ReactNode }) {
  const { pathname } = useLocation();
  useEffect(() => {
    const meta = META[pathname];
    if (!meta) return;
    document.title = meta.title;
    document.querySelector('meta[name="description"]')?.setAttribute("content", meta.description);
    document
      .querySelector('link[rel="canonical"]')
      ?.setAttribute("href", `https://scorio.live${pathname}`);
    for (const name of ["og:title", "twitter:title"])
      document
        .querySelector(`meta[property="${name}"],meta[name="${name}"]`)
        ?.setAttribute("content", meta.title);
    for (const name of ["og:description", "twitter:description"])
      document
        .querySelector(`meta[property="${name}"],meta[name="${name}"]`)
        ?.setAttribute("content", meta.description);
    document
      .querySelector('meta[property="og:url"]')
      ?.setAttribute("content", `https://scorio.live${pathname}`);
    const robots = document.querySelector('meta[name="robots"]');
    if (["/terms", "/privacy", "/refunds"].includes(pathname)) {
      const tag = robots ?? document.createElement("meta");
      tag.setAttribute("name", "robots");
      tag.setAttribute("content", "noindex, follow");
      if (!robots) document.head.append(tag);
    } else robots?.remove();
  }, [pathname]);
  return (
    <div className="sc-public">
      <a className="sc-skip" href="#public-main">
        Skip to content
      </a>
      <header className="sc-nav">
        <Link className="sc-brand" to="/" aria-label="Scorio home">
          Scorio<span aria-hidden="true">.</span>
        </Link>
        <nav aria-label="Public navigation">
          <a href="/#product">Product</a>
          <Link to="/pricing">Pricing</Link>
          <Link to="/results/demo">Try demo</Link>
          <Link className="sc-button sc-button-small" to="/login">
            Sign in
          </Link>
        </nav>
      </header>
      <main id="public-main">{children}</main>
      <footer className="sc-footer">
        <div>
          <Link className="sc-brand" to="/">
            Scorio<span>.</span>
          </Link>
          <p>Competition, clearly.</p>
        </div>
        <nav aria-label="Footer">
          <Link to="/support">Support</Link>
          <Link to="/training">Training</Link>
          <Link to="/terms">Terms</Link>
          <Link to="/privacy">Privacy</Link>
          <Link to="/refunds">Refund terms</Link>
          <a href="mailto:hello@scorio.live">Contact</a>
        </nav>
        <small>© {new Date().getFullYear()} Scorio</small>
      </footer>
    </div>
  );
}
